module.exports = __webpack_public_path__ + "static/media/2.13a9fa09.png";